import type {
  BotProtectionProviderId,
  BotProtectionRuntimeConfig,
  BotProtectionRuntimeMode,
} from './types'

const DEFAULT_RUNTIME_CONFIG: BotProtectionRuntimeConfig = {
  enabled: false,
  providerId: null,
  mode: 'disabled',
  client: null,
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const parseMode = (value: unknown): BotProtectionRuntimeMode => {
  if (value === 'soft' || value === 'strict' || value === 'disabled') {
    return value
  }
  return 'disabled'
}

const parseProviderId = (value: unknown): BotProtectionProviderId | null => {
  if (typeof value !== 'string') return null
  const normalized = value.trim()
  return normalized.length > 0 ? (normalized as BotProtectionProviderId) : null
}

const parseClientConfig = (value: unknown): Record<string, unknown> | null =>
  isRecord(value) ? value : null

export const resolveBotProtectionRuntimeConfig = (payload: unknown): BotProtectionRuntimeConfig => {
  if (!isRecord(payload) || !isRecord(payload.botProtection)) {
    return DEFAULT_RUNTIME_CONFIG
  }

  const runtime = payload.botProtection
  const enabled = runtime.enabled === true
  const providerId = parseProviderId(runtime.providerId)
  const mode = parseMode(runtime.mode)
  const client = parseClientConfig(runtime.client)

  if (!enabled || !providerId || !client) {
    return {
      enabled: false,
      providerId,
      mode,
      client,
    }
  }

  return {
    enabled: true,
    providerId,
    mode,
    client,
  }
}
